<template>
    <div class="all-table" :style="noHeight ? 'height:100%;' : 'height:' + heightCount + 'px'">
      <div class="table">
        <div class="table-filed table-title">
          <div class="table-title-item" :class="`filed-${item.id}`" v-for="item in titleListComp" :key="item.id" :style="{
            width: item.width + 'px',
            flex: item.width ? '' : 1,
          }">{{ item.name }}</div>
        </div>
        <div class="table-filed">
          <div v-for="(li, idx) in initiateArr" @click="goTable(li)" :key="idx" class="table-filed-content">
            <div class="check-radio" :class="reportCheck(li)?'check-active':''" v-if="isBatch">
              <div class="check-radio-item">
              </div>
            </div>
            <div class="table-filed-item" :class="`filed-${list.id}`" v-for="list in titleListComp" :key="list.id" :style="{
              width: list.width + 'px',
              flex: list.width ? '' : 1,
              flexShrink: list.width ? 0 : '',
            }">
              <template v-if="list.value === 'name'">
                <span>{{ li[list.value] }}</span>
                <template v-for="(item, index) in (typeof li.orgname === 'string' ? orgFun(li.orgname) : li.orgname)" :key="index">
                  <span class="td-org" :key="index" v-if="index < 3">{{item}}</span>
                </template>
              </template> 
              <template v-else-if="list.value === 'content'">
                <span v-for="(item, index) in li[list.value]" :key="index">
                  {{ `${item.title}: ${item.value}` }}
                </span>
              </template>
              <template v-else-if="list.value === 'appname'">
                <span>{{ li[list.value] }}</span>
              </template>
              <template v-else-if="list.value === 'orders'">
                {{ li.approving ? formatDateFun(li.approving.orders, 'yyyy年MM月dd日 hh:mm') : '' }}
              </template>
              <template v-else-if="list.value === 'status'">
                <span class="status-block" :class="statusType[li.approving.status].class">{{ getStatus(li) }}</span>
              </template>
              <template v-else-if="list.value === 'todo'">
                <template v-if="approselList.length !== 0 && simphaddle === 1">
                  <span class="success-text agency-text" @click.stop="approvalData(li,1)" v-if="dictionaries(li)[0] && dictionaries(li)[0].title">{{ dictionaries(li)[0].title || '同意' }}</span>
                  <span class="limit"></span>
                  <span class="back-text agency-text" @click.stop="approvalData(li,2)" v-if="dictionaries(li)[1].title">{{ dictionaries(li)[1].title }}</span>
                </template>
              </template>
            </div>
          </div>
        </div> 
        <div class="no-date" v-if="initiateArr && initiateArr.length === 0">暂无数据</div>
      </div>
      <oaExamineComment ref="oaExamineComment" @retSubComment="$emit('regetlist')" @allBatch="handleAllBatch"></oaExamineComment>
    </div>
</template>

<script>
import { formatDate  } from "@/api/global";
import { getStatusShowText, getStatusBtnText } from "@/api/utils";
import { validateupdateuserapproving, openapiUpdateuserapproving, batchupdateapprovalprocess, batchvalidateupdateuserapproving } from '@/port/clientSide/oaExamine.js'
import { apiGetapprovalselection } from '@/port/clientSide/oaExamineAudit.js'
import { statusType } from '@/util/constants'
// import oaExamineComment from '@/components/clientSide/oaExamineComment.vue'
export default {
  props: ["initiateArr", "isIndex", "isStatInitiate", "isMy", "noHeight","isTreatMe","approId","isBatch","simphaddle"],
  data () {
    return {
      heightCount: null,
      heightFunt: null,
      overId: null,
      reportActive: [],
      // 选择的数据 存的是useapprovalid
      approselList: [],
      spaceid:this.$route.query.spaceid,
      upaceid: this.$route.query.upaceid,
      titleList: [
        {
          id: 1,
          value: 'name',
          name: '发起人',
          width: 262
        },
        {
          id: 4,
          value: 'content',
          name: '内容'
        },
        {
          id: 2,
          value: 'appname',
          name: '应用',
          width: 236
        },
        {
          id: 5,
          value: 'orders',
          name: '提交日期',
          width: 241
        },
        {
          id: 6,
          value: 'status',
          name: '处理状态',
          width: 107
        },
        {
          id: 7,
          value: 'todo',
          name: '操作',
          width: 107
        },
      ],
      statusType,
    }
  },
  mounted(){
    if (!this.noHeight) {
      //获取高度
      let self = this
      this.$nextTick(function () {
        self.heightFun()
        self.heightFunt = window.addEventListener('resize', function(){
          self.heightFun()
        })
      })
    }
  },
  watch: {
    approId: {
      handler(val) {
        this.approselList = []
        this.getApproselList(val)
      }
    },
    isBatch: {
      handler(val) {
        if (!val) this.reportActive = []
      }
    }
  },
  beforeUnmount() {
    this.heightFunt = null;
  },
  components: {
    // oaExamineComment
  },
  computed: {
    titleListComp() {
      if (this.isTreatMe && this.approId && this.approId!== '-1' && !this.isBatch) {
        return this.titleList
      } else {
        return this.titleList.filter(item => item.id !== 7)
      }
    },
  },
  methods: {
    getStatus(item){
      return getStatusShowText(item)
    },
    reportCheck(item) {
				return this.reportActive.find(r => item.userapprovingId === r) !== undefined;
		},
    dictionaries(item) {
      const approsel = item.approsel
      const btns = [
        {
          title: '同意',
          status:1
        },
				{
          title: '退回',
          status:2
				},
      ]
      if (this.approselList.length === 0) return btns
      const flag = getStatusBtnText(item)
      let list = []
      if (flag) {
        list = flag
      } else {
        if (approsel === -1) {
          list = this.approselList[this.approselList.length - 1] && this.approselList[this.approselList.length - 1].split('|')
        } else{
          list = this.approselList[item.approsel] && this.approselList[item.approsel].split('|')
        }
      }
      btns[0].title = list[0]
			btns[1].title = list[1]
      btns.filter(item => item.title)
      return btns
    },
    async getApproselList(approvalId) {
      if (!approvalId || approvalId === '-1') return
      const _param = { approvalId }
      if (this.spaceid) {
        _param.spaceid = this.spaceid
      }
      else if (this.upaceid) {
        _param.upaceid = this.upaceid
      }
			const { code, data } = await apiGetapprovalselection(_param)
			if (code === 0) {
				this.approselList = data
			}
		},
    getTmp (item) {
      try {
        return item.type === 'checkbox' ? item.value ? item.value.join(',') : '' : item.value
      } catch (e) {
        return item.value
      }
    },
    orgFun(val) {
      let ars = [];
      try{
        ars = val.split(',');
      }
      catch(e) {
        ars = val;
      }
      return ars;
    },
    heightFun() {
      try{
        let heightCount = document.getElementsByClassName('oaExamine')[0].clientHeight;
        let nav = document.getElementsByClassName('el-tabs__header')[0]
        let search = document.getElementsByClassName('nav-list')[Number(this.isIndex) - 1];
        console.log('高度结果1', heightCount)
        heightCount -= 5 + 60;
        // heightCount -= 28 + 38 + 60;
        if (nav) heightCount -= nav.clientHeight;
        if (search) heightCount -= search.clientHeight;
        if (this.initiateArr.length > 0) heightCount -= 32;
        console.log('高度结果', heightCount)
        this.heightCount = heightCount
      }
      catch(error){
        console.log('高度设置错误')
      }
    },
    formatDateFun(val, format) {
      return formatDate(val, format)
    },
    checkReport(item) {
			const idx = this.reportActive.findIndex(r => r === item.userapprovingId);
			if (idx === -1) {
				this.reportActive.push(item.userapprovingId);
			} else {
				this.reportActive.splice(idx, 1);
			}
		},
    goTable(row) {
      if (this.isBatch) {
        // 如果是批量选择的话  就直接点击就可以选择
        this.checkReport(row)
      } else {
        this.$emit('goInfo', row)
      }
    },
    popOver(val){
      this.overId = val;
    },
    popOut(){
      this.overId = null;
    },
    async isRequiredWrite(item){
      const obj = {
        approvalId:item.approving.approvalId,
        userApprovingId:item.userapprovingId,
        approvingId:item.approving.approvingId
      }
      if (this.spaceid) {
        obj.spaceid = this.spaceid
      }
      else if (this.upaceid) {
        obj.upaceid = this.upaceid
      }
      const {code,data} = await validateupdateuserapproving(obj)
      if (code === 0) {
        return data
      } else {
        return false
      }
    },
    handleAllBatch(value) {
      this.yesComment(undefined, value.status, value)
    },
    async yesComment(item, status = 1,e = {}) {
      // item 列表数据的item  status  1同意 2拒绝
      const { comment = '', notefile = [], sign = '' } = e
      console.log(e);
      const isAll = Boolean(item)
      if (!isAll) {
        // 批量同意/拒绝
        const obj = {
          status,
          comment,
          notefile,
          userapprovingIds: this.reportActive.join(','),
          sign,
        }
        if (this.spaceid) {
          obj.spaceid = this.spaceid
        }
        else if (this.upaceid) {
          obj.upaceid = this.upaceid
        }
        const { code } = await batchupdateapprovalprocess(obj)
        if (code === 0) {
          this.reportActive = []
          this.$message.success('批量审批成功')
        } else {
          this.$message.success('批量审批失败')
        }
      } else {
        // 单个同意/拒绝
        const obj = {
          status,
          comment,
          notefile,
          sign,
          outup:1,
          userapprovingId: item.userapprovingId,
        }
        if (this.spaceid) {
          obj.spaceid = this.spaceid
        }
        const { code } = await openapiUpdateuserapproving(obj);
        if (code === 0) {
          this.$message.success('审批成功')
        } else {
          this.$message.success('审批失败')
        }
      }
      this.$emit('regetlist')
    },
    getBatchContent(list) {
      // 拥有必填字段的的数据
			const content = []
			list.forEach(item=>{
				if (this.reportActive.findIndex(f=>f === item.userapprovingId) !== -1) {
					const obj = {
						approvingId:item.approving.approvingId,
						userApprovingId:item.userapprovingId,
						approvalId:item.approving.approvalId
					}
					content.push(obj)
				}
			})
			return content
    },
    
    async batchAll(status) {
      // 审批选中的数据
      if (this.reportActive.length === 0) {
        this.$message.error('请选择数据')
				return;
      }
      const data = await this.isRequiredField()
      if (!data) return
      let iscomment = 0
      let issign = 0
      this.reportActive.forEach(i => {
				if (this.initiateArr.find(r => r.userapprovingId === i) && this.initiateArr.find(r => r.userapprovingId === i).issign === 1) {
					this.issign = 1;
				}
				if (this.initiateArr.find(r => r.userapprovingId === i) && this.initiateArr.find(r => r.userapprovingId === i).iscomment === 1) {
					this.iscomment = 1;
				}
      });
      const obj = {
        1: '批量同意',
        2: '批量退回'
      }
      if (issign === 1 || iscomment === 1) {
        let date = {
          stat: 2, //状态说明（1 评论 2 处理事件说明 3 转办）
          formdata: undefined,
          item: 1,
          isComment: iscomment,
          issign: issign,
          text: obj[status],
          isBatch:true
        };
        this.$refs.oaExamineComment.oaExamineCommentFun(date, true);
      } else {
        this.yesComment(undefined,status)
      }
    },
    async isRequiredField(status) {
      // 判断所选中的数据中是否有必填字段
			let content = this.getBatchContent(this.initiateArr)
			const obj = {
				content:JSON.stringify(content)
      }
      if (this.spaceid) {
        obj.spaceid = this.spaceid
      }
      else if (this.upaceid) {
        obj.upaceid = this.upaceid
      }
			const { code, data, msg } = await batchvalidateupdateuserapproving(obj)
			if (code === 0) {
				if (Array.isArray(data)) {
					// 说明有必填字段和没必填字段混合在一起了
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 确定的话 直接将没有必填字段的id给过滤出来  并且重新赋值
            const batchApprovalId = content.filter(item=> data.findIndex(f=>f === item.approvingId) !== -1)
            this.reportActive = this.reportActive.filter(item => batchApprovalId.findIndex(f => f.userApprovingId === item) !== -1)
            this.batchAll(status)
          }).catch(() => {
            return false
          });
					return false
        } else {
					return true
				}
      } else {
        this.$message.error(msg)
      }
		},
    async approvalData(item, status) {
      // 审批单条数据
      const isRequired = await this.isRequiredWrite(item)
      if (isRequired === false) {
        this.$message.error('拥有必填字段，请到详情页再继续操作')
        this.goTable(item)
        return
      }
      if (item.issign === 1 || item.iscomment === 1) {
        let date = {
          stat: 2, //状态说明（1 评论 2 处理事件说明 3 转办）
          userapprovingId: item.userapprovingId,
          formdata: undefined,
          item: 1,
          isComment: item.iscomment,
          issign: item.issign,
          text: this.dictionaries(item)[Number(status) - 1].title
        };
        this.$refs.oaExamineComment.oaExamineCommentFun(date, true);
      } else {
        this.yesComment(item,status)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  // @import "~@/assets/css/clientSide/oaExamine.scss";


.all-table {
  .table {
    display: block; 
    .table-title {
      height: 40px;
      background-color: #F8F9FB;
      display: flex;
      align-items: center;
      &-item {
        color: #333333;
        font-weight: 400;
        font-size: 14px;
      }
    }
    .table-filed {
      &-content {
        height: 50px;
        display: flex;
        align-items: center;
        border-bottom: solid 1px #EBEEF5;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
      }

      .status-block {
        padding: 3px 12px;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 14px;
        box-sizing: border-box;
      }

      .limit {
        width: 1px;
        height: 12px;
        display: inline-block;
        background-color: #A2A3A5;
        margin: 0 10px;
      }

      .agency-text{
        font-weight: 400;
        color: #67B2FF;
      }
      .back-text{
        color: #da5757 !important;
      }

      .processing {
        background-color: #FFEDE2;
        color: #FF8554;
      }

      .passed {
        color: #4E70FF;
        background-color: #E3ECFF;
      }

      .refuse {
        color: #FF5454;
        background-color: #FFE4E4;
      }
      .cancle {
        color: #7E7E7E;
        background-color: #E7E7E7;
      }

      .filed-1 {
        padding-left: 32px;
        box-sizing: border-box;
      }
      .filed-4 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .filed-2 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-left: 64px;
      }
      .filed-5 {
        padding-left: 32px;
      }
    }
  }
}

.table-list {
  padding: 7px 0;
  width: 99%;
  margin-left: 10px;
  color: #666666;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.14);
  border-radius: 8px;
  position: relative;
}
.check-radio{
  display: flex;
  border-radius: 100%;
  width: 14px;
  height: 14px;
  align-items: center;
  justify-content: center;
  border: solid 1px #A6A6A6;
  box-sizing: border-box;
  position: absolute;
  left: 5px;
  top: calc(50% - 7px);
  &-item {
    background-color: #fff;
    width: 4px;
    height: 4px;
    border-radius: 100%;
  }
}
.check-active {
  background: #057EFF;
}
.td-center {
  width: 207px;
  text-align: left;
  padding-left: 28px;
  .td-name {
    text-align: left;
  }
}
.td-2 {
  width: 84px;
  min-width: 84px;
  padding-right: 40px;
}
.td-5 {
  padding-right: 50px;
  min-width: 60px;
}

.td-6 {
  min-width: 110px;
  text-align: center;
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .agency-text{
    font-weight: 400;
    color: #67B2FF;
  }
  .back-text{
    color: #da5757 !important;
  }
  .limit {
    width: 1px;
    height: 12px;
    display: inline-block;
    background-color: #A2A3A5;
    margin: 0 10px;
  }
}

</style>
